import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import cx from "classnames";
import { Modal, Input, message } from "antd";
import styles from "./brandKindSelect.module.less";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import { IBrandDataSource, IKindDataSource, IkindList } from "./types";

interface IModalPopover {
  value: string | number;
  dataSource: IKindDataSource;
  onSelect: (data: IkindList) => void;
}

function ModalYearPopover(props: IModalPopover) {
  const { value, onSelect, dataSource } = props;

  return (
    <>
      <div className={styles["select-popover-header"]}>
        <p>車型</p>
      </div>
      <div style={{ left: 0, width: "240px" }} className={cx(styles["select-popover-list"])}>
        <PerfectScrollbar>
          {dataSource.map((item) => (
            <div
              className={cx(styles["select-popover-section"], "tc-select-section")}
              key={item.label}
              data-index={item.label}
            >
              <span className={styles["select-popover-section-header"]}>{item.label}</span>
              {item.list.map((ii) => (
                <span
                  className={cx(styles["select-popover-section-item"], styles["select-popover-model-section-item"], {
                    [styles["active"]]: value === ii.id,
                  })}
                  key={ii.id}
                  onClick={() => onSelect({ ...ii })}
                >
                  {ii.name}
                </span>
              ))}
            </div>
          ))}
        </PerfectScrollbar>
      </div>
    </>
  );
}

interface IModal {
  initValue: {
    modelYearId: string | number;
    modelYearName: string;
  };
  dataSource: IKindDataSource;
  onSelect: (data: IkindList) => void;
}

const ModelYearPopoverWrapper: React.FC<IModal> = ({ initValue, dataSource, onSelect }) => {
  const [label, setLabel] = useState<string>("");
  const [value, setValue] = useState<number | string>(0);

  const select = (data: IkindList) => {
    setValue(data.id);
    setLabel(data.name);
    onSelect(data);
  };

  useEffect(() => {
    setLabel(initValue.modelYearName);
    setValue(initValue.modelYearId);
  }, [initValue]);

  return <ModalYearPopover dataSource={dataSource} value={value} onSelect={select} />;
};

export default ModelYearPopoverWrapper;
